import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SnackBarUI from '../../comman/SnackBarUI'
import { getMissionAction } from '../../redux/toolkit/mission/getMission'
import { restoreMissionAction } from '../../redux/toolkit/mission/restoreMission'
import PropTypes from 'prop-types';


export default function RestoreMission({ mission_id, state, setState }) {
    // state
    const dispatch = useDispatch()
    const restoreMission = useSelector(state => state.restoreMission)
    const { status, message } = restoreMission

    const [snack, setSnack] = useState(false)

    // fn
    const handleClose = () => {
        setState(false)
    }

    const delCatHandle = async () => {
        await dispatch(restoreMissionAction(mission_id))
        await dispatch(getMissionAction({ is_deleted: true }))
        setSnack(true)
        setState(false)
    }

    return (
        <>
            <Dialog open={state} onClose={handleClose}>
                <DialogTitle>Restore item request !</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to restore the selected mission ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={delCatHandle} autoFocus> Agree</Button>
                    <Button onClick={handleClose}>Disagree</Button>
                </DialogActions>
            </Dialog>


            <SnackBarUI state={snack} setState={setSnack} status={status} message={message} />
        </>

    )
}

RestoreMission.propTypes = {
    mission_id: PropTypes.string,
    state: PropTypes.any,
    setState: PropTypes.any
};